import React, { useContext } from 'react';
import Select from 'react-select';
import { CurrencyContext } from '../../utils/currencyContext/index';
import DropdownIndicator from '../common/dropdownIndicator';
import { currencyOptions } from '../../resources/static';
import './currencySwitcher.scss';

function CurrencySwitcher() {
    const { currentCurrency, setCurrency } = useContext(CurrencyContext);

    const formatOptionLabel = ({ label, sign }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className="currency-sign">{sign}</span>
            <span>{label}</span>
        </div>
    );

    const changeCurrency = (option) => {
        const currencyCode = option.value;
        setCurrency(currencyCode);
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            background: 'transparent',
            border: 0,
            boxShadow: 0,
            cursor: 'pointer',
            minHeight: 'auto'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: 0
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#fff',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '17px',
            width: '51px'
        }),
        menuList: (provided) => ({
            ...provided,
            '.currency-sign': {
                color: 'inherit',
                height: 'auto',
                marginRight: '3px',
                width: 'auto'
            }
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: state.isSelected ? '#00AF60' : '#0A100D',
            cursor: 'pointer',
            '&:hover': {
                ...provided['&:hover'],
                color: '#00AF60',
                backgroundColor: 'transparent'
            }
        })
    };

    return (
        <Select
            value={currencyOptions.find((o) => o.value === currentCurrency)}
            onChange={changeCurrency}
            options={currencyOptions}
            styles={customStyles}
            formatOptionLabel={formatOptionLabel}
            components={{ DropdownIndicator }}
            isSearchable={false}
            className="currency-switcher"
        />
    );
}

export default CurrencySwitcher;
